import { render, staticRenderFns } from "./mainlandfreight-edit.vue?vue&type=template&id=4d746870"
import script from "./mainlandfreight-edit.vue?vue&type=script&lang=ts"
export * from "./mainlandfreight-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports